import { Grow, useMediaQuery } from "@mui/material";
import { RiCalendar2Line } from "react-icons/ri";

const BlogItem = ({ data, index, visible }) => {
  const matches = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  return (
    <div className="border-b border-gray-200 flex flex-col gap-4 pb-8 w-full sm:flex-row sm:gap-8 sm:pb-10">
      <Grow key={index} in={visible} timeout={1000 + index * 500}>
        <div className="border border-gray-200 h-[240px] overflow-hidden rounded-sm w-full sm:h-[300px]">
          <div
            className="!bg-cover bg-gray-100 !bg-center !bg-no-repeat h-full w-full"
            style={{
              background: `url(${
                matches ? data.thumbnail.highRes : data.thumbnail.highRes
              })`,
            }}
          />
        </div>
      </Grow>

      <div className="flex flex-col gap-5 w-full sm:gap-9 sm:py-1">
        <div className="flex flex-col space-y-3">
          {data.link ? (
            <p className="font-bold leading-normal line-clamp-2 text-secondary text-lg sm:text-2xl">
              {data.title}
            </p>
          ) : (
            <p className="font-bold leading-normal line-clamp-2 text-gray-600 text-lg sm:text-2xl">
              {data.title}
            </p>
          )}

          <div className="flex items-center space-x-2">
            <RiCalendar2Line className="text-gray-600 text-lg" />
            <p className="font-normal leading-normal text-gray-600 text-start text-xs sm:text-sm">
              {data.date}
            </p>
          </div>

          <p className="font-normal leading-normal line-clamp-3 text-gray-600 text-start text-sm sm:text-base">
            {data.content}
          </p>
        </div>

        <div className="flex flex-col gap-3 items-start w-full sm:flex-row">
          <a
            className="no-underline w-full"
            href={data.link["en"]}
            rel="noopener noreferrer"
            target="_blank"
          >
            <button className="btn-custom btn-primary w-full">
              English Edition
            </button>
          </a>

          <a
            className="no-underline w-full"
            href={data.link["cn"]}
            rel="noopener noreferrer"
            target="_blank"
          >
            <button className="btn-custom btn-secondary !border-primary !text-primary w-full hover:!border-primary-dark hover:!text-primary-dark">
              中文版
            </button>
          </a>
        </div>
      </div>
    </div>
  );
};

export default BlogItem;
